import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Snackbar from "@material-ui/core/Snackbar";
import { editMyEvent } from "../../helpers/events";
import catchErrors from "../../helpers/catchErrors";

import MuiAlert from "@material-ui/lab/Alert";
import Layout from "../../hoc/Layout";
import EditForm from "../../components/Events/EditForm";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const INITIAL_STATE = {
  title: "",
  desc: "",
  date: "",
  time: "",
};

const EditEvent = ({ location, history }) => {
  const { user } = useSelector((state) => ({ ...state }));

  const [values, setValues] = useState({ ...location.state });
  const [error, setError] = useState("");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    const oldDate = location.state.date;
    console.log(oldDate);
    setValues((prevState) => ({
      ...prevState,
      date: oldDate.split("T")[0],
    }));
  }, []);

  //   console.log(location.state._id);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    history.push("/user/events");
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    // console.log(value);
    setValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  async function handleSubmit(event) {
    event.preventDefault();
    setLoading(true);
    try {
      setError("");

      const userToken = user.token;
      const response = await editMyEvent(userToken, values, location.state._id);
      setOpen(true);
    } catch (error) {
      catchErrors(error, setError);
    } finally {
      // console.log(values);
      setLoading(false);
    }
  }

  const resetForm = () => {
    setIsDisabled(true);
    setValues(INITIAL_STATE);
  };
  return (
    <Layout>
      <div className="createImage"></div>
      <div className="home">
        <h2 className="secTitle">Edit Event</h2>{" "}
        <Snackbar
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert onClose={handleClose} severity="success">
            <h3>Event edited successfully!</h3>
            <h4>You will now be redirected to your events...</h4>
          </Alert>
        </Snackbar>
        <div className="regForm">
          <h2 className="subTitle">Edit: "{location.state.title}"</h2>
          <h3 className="subTitle">Be sure to get all the info correct :)</h3>

          <EditForm
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            values={values}
            resetForm={resetForm}
            isDisabled={isDisabled}
          />
        </div>
      </div>
    </Layout>
  );
};

export default EditEvent;
